<script lang="ts">
export const elLogoColors = ['two-tone', 'white', 'dark'] as const;
export type ElLogoColors = (typeof elLogoColors)[number];
export const elLogoVariants = ['full', 'compact', 'basic'] as const;
export type ElLogoVariants = (typeof elLogoVariants)[number];
</script>

<script lang="ts" setup>
import heartTwoTone from '@/assets/logo/heart-two-tone.svg';
import heartWhite from '@/assets/logo/heart-white.svg';
import heartDark from '@/assets/logo/heart-dark.svg';
import eltyTwoTone from '@/assets/logo/elty-two-tone.svg';
import eltyWhite from '@/assets/logo/elty-white.svg';
import eltyDark from '@/assets/logo/elty-dark.svg';
import davinciWhite from '@/assets/logo/davinci-white.svg';
import davinciDark from '@/assets/logo/davinci-dark.svg';

withDefaults(
  defineProps<{
    color?: ElLogoColors;
    variant?: ElLogoVariants;
  }>(),
  {
    color: 'two-tone',
    variant: 'full',
  },
);
</script>

<template>
  <div class="flex items-start justify-center gap-[2px]">
    <img
      :src="
        {
          'two-tone': heartTwoTone,
          white: heartWhite,
          dark: heartDark,
        }[color]
      "
      :class="
        {
          full: 'w-[37px] h-[20px]',
          compact: 'w-[37px] h-[20px]',
          basic: 'w-[50px] h-[28px]',
        }[variant]
      "
      alt="Heart"
    />
    <img
      :src="
        {
          'two-tone': eltyTwoTone,
          white: eltyWhite,
          dark: eltyDark,
        }[color]
      "
      :class="
        {
          full: 'w-[55px] h-[28px]',
          compact: 'w-[55px] h-[28px]',
          basic: 'hidden',
        }[variant]
      "
      alt="Elty"
    />
    <img
      :src="
        {
          'two-tone': davinciDark,
          white: davinciWhite,
          dark: davinciDark,
        }[color]
      "
      :class="
        {
          full: 'w-[100px] h-[20px]',
          compact: 'hidden',
          basic: 'hidden',
        }[variant]
      "
      alt="Davinci"
    />
  </div>
</template>
